/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 as Typography } from '@coursera/cds-core';

import _t from 'i18n!nls/reviews';

type ToggleButtonForTogglableContentProps = {
  collapsed: boolean;
};

const styles = {
  label: css`
    color: var(--cds-color-interactive-primary);
  `,
};

const ToggleButtonForTogglableContent = ({ collapsed }: ToggleButtonForTogglableContentProps) => {
  return (
    <Typography variant="actionSecondary" component="span" css={styles.label}>
      {collapsed ? _t('Show more') : _t('Show less')}
    </Typography>
  );
};

export default ToggleButtonForTogglableContent;
